export function isObject(obj) {
    return typeof obj === "object" && !Array.isArray(obj) && obj !== null;
}
export function isArray(value) {
    return Array.isArray(value);
}
export function isBoolean(value) {
    return typeof value === "boolean";
}
export function isString(value) {
    return typeof value === "string";
}
export function isNumber(value) {
    return typeof value === "number";
}
export function isNull(value) {
    return value === null;
}
//# sourceMappingURL=utils.js.map